// Generated by purs version 0.14.3
"use strict";
var Data_Either = require("../Data.Either/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_FoldableWithIndex = require("../Data.FoldableWithIndex/index.js");
var Data_Functor_Variant = require("../Data.Functor.Variant/index.js");
var Data_Variant = require("../Data.Variant/index.js");
var Record = require("../Record/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var HFoldlWithIndex = function (hfoldlWithIndex) {
    this.hfoldlWithIndex = hfoldlWithIndex;
};
var HFoldl = function (hfoldl) {
    this.hfoldl = hfoldl;
};
var FoldlVariantF = function (foldlVariantFRowList) {
    this.foldlVariantFRowList = foldlVariantFRowList;
};
var FoldlVariant = function (foldlVariantRowList) {
    this.foldlVariantRowList = foldlVariantRowList;
};
var FoldlRecord = function (foldlRecordRowList) {
    this.foldlRecordRowList = foldlRecordRowList;
};
var FoldingWithIndex = function (foldingWithIndex) {
    this.foldingWithIndex = foldingWithIndex;
};
var Folding = function (folding) {
    this.folding = folding;
};
var ConstFolding = function (x) {
    return x;
};
var hfoldlWithIndexRowListNil = new HFoldlWithIndex(function (v) {
    return function (x) {
        return function (v1) {
            return x;
        };
    };
});
var hfoldlWithIndex = function (dict) {
    return dict.hfoldlWithIndex;
};
var hfoldlRowList = function (dictHFoldlWithIndex) {
    return new HFoldl(function (f) {
        return hfoldlWithIndex(dictHFoldlWithIndex)(f);
    });
};
var hfoldl = function (dict) {
    return dict.hfoldl;
};
var functionFoldingWithIndex = new FoldingWithIndex(function (f) {
    return f;
});
var functionFolding = new Folding(function (f) {
    return f;
});
var foldlVariantRowList = function (dict) {
    return dict.foldlVariantRowList;
};
var hfoldlVariant = function (dictRowToList) {
    return function (dictFoldlVariant) {
        return new HFoldl((function () {
            var $73 = foldlVariantRowList(dictFoldlVariant)(Type_Proxy["Proxy"].value);
            return function ($74) {
                return $73(ConstFolding($74));
            };
        })());
    };
};
var hfoldlVariantWithIndex = function (dictRowToList) {
    return function (dictFoldlVariant) {
        return new HFoldlWithIndex(foldlVariantRowList(dictFoldlVariant)(Type_Proxy["Proxy"].value));
    };
};
var foldlVariantNil = new FoldlVariant(function (v) {
    return function (v1) {
        return function (v2) {
            return Data_Variant.case_;
        };
    };
});
var foldlVariantFRowList = function (dict) {
    return dict.foldlVariantFRowList;
};
var hfoldlVariantF = function (dictRowToList) {
    return function (dictFoldlVariantF) {
        return new HFoldl((function () {
            var $75 = foldlVariantFRowList(dictFoldlVariantF)(Type_Proxy["Proxy"].value);
            return function ($76) {
                return $75(ConstFolding($76));
            };
        })());
    };
};
var hfoldlVariantFWithIndex = function (dictRowToList) {
    return function (dictFoldlVariantF) {
        return new HFoldlWithIndex(foldlVariantFRowList(dictFoldlVariantF)(Type_Proxy["Proxy"].value));
    };
};
var foldlVariantFNil = new FoldlVariantF(function (v) {
    return function (v1) {
        return function (v2) {
            return Data_Functor_Variant.case_;
        };
    };
});
var foldlRecordRowList = function (dict) {
    return dict.foldlRecordRowList;
};
var hfoldlRecord = function (dictRowToList) {
    return function (dictFoldlRecord) {
        return new HFoldl(function (f) {
            return function (x) {
                return foldlRecordRowList(dictFoldlRecord)(f)(x)(Type_Proxy["Proxy"].value);
            };
        });
    };
};
var hfoldlRecordWithIndex = function (dictRowToList) {
    return function (dictFoldlRecord) {
        return new HFoldlWithIndex(function (f) {
            return function (x) {
                return foldlRecordRowList(dictFoldlRecord)(f)(x)(Type_Proxy["Proxy"].value);
            };
        });
    };
};
var foldlRecordNil = new FoldlRecord(function (v) {
    return function (x) {
        return function (v1) {
            return function (v2) {
                return x;
            };
        };
    };
});
var foldingWithIndex = function (dict) {
    return dict.foldingWithIndex;
};
var foldlRecordCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictFoldingWithIndex) {
            return function (dictFoldlRecord) {
                return new FoldlRecord(function (f) {
                    return function (x) {
                        return function (v) {
                            return function (r) {
                                return foldlRecordRowList(dictFoldlRecord)(f)(foldingWithIndex(dictFoldingWithIndex)(f)(Type_Proxy["Proxy"].value)(x)(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(r)))(Type_Proxy["Proxy"].value)(r);
                            };
                        };
                    };
                });
            };
        };
    };
};
var foldlVariantCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictFoldingWithIndex) {
            return function (dictFoldlVariant) {
                return new FoldlVariant(function (v) {
                    return function (f) {
                        return function (x) {
                            return Data_Variant.on()(dictIsSymbol)(Type_Proxy["Proxy"].value)(foldingWithIndex(dictFoldingWithIndex)(f)(Type_Proxy["Proxy"].value)(x))(foldlVariantRowList(dictFoldlVariant)(Type_Proxy["Proxy"].value)(f)(x));
                        };
                    };
                });
            };
        };
    };
};
var foldlVariantFCons = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictFoldingWithIndex) {
            return function (dictFoldlVariantF) {
                return new FoldlVariantF(function (v) {
                    return function (f) {
                        return function (x) {
                            return Data_Functor_Variant.on()(dictIsSymbol)(Type_Proxy["Proxy"].value)(foldingWithIndex(dictFoldingWithIndex)(f)(Type_Proxy["Proxy"].value)(x))(foldlVariantFRowList(dictFoldlVariantF)(Type_Proxy["Proxy"].value)(f)(x));
                        };
                    };
                });
            };
        };
    };
};
var hfoldlWithIndexApp = function (dictFoldableWithIndex) {
    return function (dictFoldingWithIndex) {
        return new HFoldlWithIndex(function (f) {
            return function (x) {
                return function (v) {
                    return Data_FoldableWithIndex.foldlWithIndex(dictFoldableWithIndex)(foldingWithIndex(dictFoldingWithIndex)(f))(x)(v);
                };
            };
        });
    };
};
var hfoldlWithIndexRowListCons = function (dictFoldingWithIndex) {
    return function (dictHFoldlWithIndex) {
        return new HFoldlWithIndex(function (f) {
            return function (x) {
                return function (v) {
                    return hfoldlWithIndex(dictHFoldlWithIndex)(f)(foldingWithIndex(dictFoldingWithIndex)(f)(Type_Proxy["Proxy"].value)(x)(Type_Proxy["Proxy"].value))(Type_Proxy["Proxy"].value);
                };
            };
        });
    };
};
var folding = function (dict) {
    return dict.folding;
};
var hfoldlApp = function (dictFoldable) {
    return function (dictFolding) {
        return new HFoldl(function (f) {
            return function (x) {
                return function (v) {
                    return Data_Foldable.foldl(dictFoldable)(folding(dictFolding)(f))(x)(v);
                };
            };
        });
    };
};
var hfoldlEither = function (dictFolding) {
    return function (dictFolding1) {
        return new HFoldl(function (f) {
            return function (x) {
                return function (v) {
                    if (v instanceof Data_Either.Left) {
                        return folding(dictFolding)(f)(x)(v.value0);
                    };
                    if (v instanceof Data_Either.Right) {
                        return folding(dictFolding1)(f)(x)(v.value0);
                    };
                    throw new Error("Failed pattern match at Heterogeneous.Folding (line 146, column 16 - line 148, column 29): " + [ v.constructor.name ]);
                };
            };
        });
    };
};
var hfoldlTuple = function (dictFolding) {
    return function (dictFolding1) {
        return new HFoldl(function (f) {
            return function (x) {
                return function (v) {
                    return folding(dictFolding1)(f)(folding(dictFolding)(f)(x)(v.value0))(v.value1);
                };
            };
        });
    };
};
var constFolding = function (dictFolding) {
    return new FoldingWithIndex(function (v) {
        return function (v1) {
            return folding(dictFolding)(v);
        };
    });
};
module.exports = {
    folding: folding,
    foldingWithIndex: foldingWithIndex,
    foldlRecordRowList: foldlRecordRowList,
    foldlVariantFRowList: foldlVariantFRowList,
    foldlVariantRowList: foldlVariantRowList,
    hfoldl: hfoldl,
    hfoldlWithIndex: hfoldlWithIndex,
    Folding: Folding,
    FoldingWithIndex: FoldingWithIndex,
    HFoldl: HFoldl,
    HFoldlWithIndex: HFoldlWithIndex,
    ConstFolding: ConstFolding,
    FoldlRecord: FoldlRecord,
    FoldlVariant: FoldlVariant,
    FoldlVariantF: FoldlVariantF,
    functionFolding: functionFolding,
    functionFoldingWithIndex: functionFoldingWithIndex,
    constFolding: constFolding,
    hfoldlApp: hfoldlApp,
    hfoldlWithIndexApp: hfoldlWithIndexApp,
    hfoldlRowList: hfoldlRowList,
    hfoldlWithIndexRowListCons: hfoldlWithIndexRowListCons,
    hfoldlWithIndexRowListNil: hfoldlWithIndexRowListNil,
    hfoldlRecord: hfoldlRecord,
    hfoldlRecordWithIndex: hfoldlRecordWithIndex,
    foldlRecordCons: foldlRecordCons,
    foldlRecordNil: foldlRecordNil,
    hfoldlTuple: hfoldlTuple,
    hfoldlEither: hfoldlEither,
    hfoldlVariant: hfoldlVariant,
    hfoldlVariantWithIndex: hfoldlVariantWithIndex,
    foldlVariantCons: foldlVariantCons,
    foldlVariantNil: foldlVariantNil,
    hfoldlVariantF: hfoldlVariantF,
    hfoldlVariantFWithIndex: hfoldlVariantFWithIndex,
    foldlVariantFCons: foldlVariantFCons,
    foldlVariantFNil: foldlVariantFNil
};
